import { AxiosError } from 'axios';
import { GET_RESIT_SUBJECTS } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { GET_RESIT_SUBJECTS_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import { ResitSubject } from '../../api/candidate/resit/model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  token?: string;
  onSuccess?: (data: ResitSubject[]) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetResitSubjects = ({ token, onSuccess, onError }: Input = {}) => {
  const getResitSubjects = async () => {
    const res = await axiosClient.get<ResitSubject[]>(GET_RESIT_SUBJECTS(token));
    return res.data;
  };

  return useCustomQuery(GET_RESIT_SUBJECTS_KEY, getResitSubjects, {
    onSuccess,
    onError,
  });
};
